import Layout from '@/layout';
var storeManagementRouter = {
  path: '/storeManagement',
  component: Layout,
  redirect: '/storeManagement/index',
  name: 'StoreManagement',
  meta: {
    title: '门店管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'index',
    name: 'StoreList',
    component: function component() {
      return import('@/views/storeManagement/index');
    },
    meta: {
      title: '门店管理',
      icon: 'clipboard'
    }
  }, {
    path: 'doctor/:storeId',
    name: 'DoctorList',
    component: function component() {
      return import('@/views/storeManagement/doctor/index');
    },
    meta: {
      title: '医生管理',
      activeMenu: '/storeManagement/index'
    },
    hidden: true
  }]
};
export default storeManagementRouter;